import selectInsurance from 'utils/selectInsurance';

const getInsuranceAccidentDate3 = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const accidentDate = selectedInsurance['Insurance Special Date'] && selectedInsurance['Insurance Special Date'].length > 0
    ? selectedInsurance['Insurance Special Date'].find(item =>
      item['Type Of Date'] === 'Accident Date')['Special Date'] : null;
  return accidentDate ? accidentDate.replace(/[/]/g, '').substring(6, 8) : null;
};

export default getInsuranceAccidentDate3;


// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceAccidentDate3.js